export type GetPortfolioSizeDifferenceWarningParams = {
  minimumInvestorPortfolioSize: number;
  leastDiversifiedTrancheInvestor: number;
  remainingTrancheInvestmentCapitalPercent: number;
  targetAllocationPercent: number;
  dealSharePrice: number;
  lowestInvestmentCapitalInSelection: number;
};

export type GetPortfolioSizeDifferenceWarningResult = {
  shouldShowInfoOverall: boolean;
  shouldShowInfoForPortfolioSizeOne: boolean;
  portfolioSizeDifference: number;
};

const getPortfolioSizeDifferenceWarning = (
  params: GetPortfolioSizeDifferenceWarningParams,
): GetPortfolioSizeDifferenceWarningResult => {
  const {
    minimumInvestorPortfolioSize,
    leastDiversifiedTrancheInvestor,
    remainingTrancheInvestmentCapitalPercent,
    targetAllocationPercent,
    dealSharePrice,
    lowestInvestmentCapitalInSelection,
  } = params;

  const portfolioSizeDifference =
    minimumInvestorPortfolioSize - leastDiversifiedTrancheInvestor;

  const remainingCapitalPercent = remainingTrancheInvestmentCapitalPercent;
  const capitalDifference = remainingCapitalPercent - targetAllocationPercent;

  const shouldShowInfo = capitalDifference < 2;

  const shouldShowInfoForPortfolioSizeOne =
    portfolioSizeDifference === 1 &&
    capitalDifference < 2 &&
    dealSharePrice > lowestInvestmentCapitalInSelection;

  const shouldShowInfoOverall =
    shouldShowInfo || shouldShowInfoForPortfolioSizeOne;

  return {
    shouldShowInfoOverall,
    shouldShowInfoForPortfolioSizeOne,
    portfolioSizeDifference,
  };
};

export default getPortfolioSizeDifferenceWarning;
